// GENERATED BY ./src/scripts/generateComponents.ts
// DO NOT EDIT IT MANUALLY

import React from "react";

import { iconBasesepoliatestnet } from "../../../icons/full/build/icon-basesepoliatestnet.icon";
import { IconComponentBaseProps } from "../../../utils";
import { Image } from "../../Base/Image";

const BasesepoliatestnetIcon = (props: IconComponentBaseProps) => {
  return <Image svgCode={iconBasesepoliatestnet.data} {...props} />;
};

if (process.env.NODE_ENV !== 'production') {
  BasesepoliatestnetIcon.displayName = 'BasesepoliatestnetIcon';
}

export default BasesepoliatestnetIcon;